import { HeatMap, Image, Label, Roi, Line, Text, TrackMark } from './elements/index.js';

const index = (elementData) => {
  let element = null;
  switch (elementData.props.type) {
    case 'heatMap':
      element = new HeatMap(elementData);
      break;
    case 'image':
      element = new Image(elementData);
      break;
    case 'label':
      element = new Label(elementData);
      break;
    case 'roi':
      element = new Roi(elementData);
      break;
    case 'line':
      element = new Line(elementData);
      break;
      // TODO渲染文本
    case 'text':
      element = new Text(elementData);
      break;
    // html渲染标记
    case 'trackMark':
      element = new TrackMark(elementData);
      break;
  }
  return element;
};

export default index;
